/**
 * Created by Sale on 10/28/2024
 */
import store from "./store";
import router from "./router";

export default {
    store,
    router
};